<script>
  import { onMount } from 'svelte';
  import { APIClient } from '../state-charts';
  import initWorkersMap from './maps.js';
  import UnauthenticatedLayout from '../app-shell/guest-app/Layout.svelte';
  import { TS } from '../config/translation-keys.js';
  import { t9n } from '../lib/translate.js';
  import { fly } from 'svelte/transition';
  import session from '../lib/session';
  import settings from '../config';

  // exported variables ---------------------------------------------------- //

  export let merchant_uuid;

  // internal variables ---------------------------------------------------- //

  let country;
  let explanation;
  let is_opened = true;
  const map_script_url = `https://maps.googleapis.com/maps/api/js?key=${settings.google_maps_api_key}&callback=init_workers_map`;

  // initialization -------------------------------------------------------- //

  const toggle_info = () => {
    is_opened = !is_opened;
  };

  const init_workers_map = async () => {
    const waiting = setInterval(() => {
      if (window && 'google' in window && $session.api_config) {
        APIClient.get_merchant_config({
          merchant_uuid: merchant_uuid,
        }).then(merchant => {
          clearInterval(waiting);
          initWorkersMap(google, merchant);
        });
      }
    }, 100);
  };

  $: explanation = t9n(TS.WORKER_MAP_SECURITY);

  onMount(() => {
    window.init_workers_map = init_workers_map;
  });
</script>

<svelte:head>
  <script src={map_script_url} defer>

  </script>
  <script src="/vendor/marker-cluster/markerclusterer.js" defer>

  </script>
</svelte:head>

<UnauthenticatedLayout>
  <div class="workers-map" slot="content">
    {#if is_opened}
      <div transition:fly={{ duration: 500 }} class="explanation">
        <p>{explanation}</p>
        <i
          class="material-icons delete-icon"
          on:click={() => toggle_info()}
          aria-hidden="true">
          close
        </i>

      </div>
    {/if}
    <div id="info_map" style="overflow: hidden" />
  </div>
</UnauthenticatedLayout>

<style>
  .workers-map .explanation p {
    display: inline !important;
  }

  .workers-map .explanation .material-icons {
    position: absolute;
    right: 13px;
    /*top: 8.5px;*/
    top: 15px;
    cursor: pointer;
  }

  .workers-map .explanation {
    position: absolute;
    display: flex;
    z-index: 2;
    /*right: 0;*/
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    top: 70px;
    /*width: 490px;*/
    width: 80%;
    padding-right: 40px;
    padding-left: 15px;
    /*padding-right: 15px;*/
    background-color: var(--mdc-theme-secondary);
    border-radius: 10px;
    color: white;
    font-size: 10pt;
  }

  #info_map {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: lightgray;
    padding-top: 50px;
  }
</style>
